import { useState, useEffect } from 'react';
import { Button, Tile } from 'carbon-components-react';
import { FormattedMessage } from 'react-intl';
import messages from '../../locales/messages';
import countryList from '../../services/currencies.json';
import { swapCountryAndLanguage } from 'src/common/utils/swapCountryAndLanguage';
import { IBMLocale } from 'src/common/locale/mapValidLocale';
import { LangDefaults, useLang } from 'src/common/hooks/widgets/useLang';
import { ArrowRight16 } from '@carbon/icons-react';
import { segmentsTracking } from 'src/common/lib/tracker';
import PublicImage from 'src/common/components/PublicImage';

export interface menuPageProps {
  langCode: string;
  test: boolean;
  countryToTest: string;
  bpName: string;
  setShowOption: React.Dispatch<React.SetStateAction<number>>;
}

const menuPage = ({
  langCode,
  test,
  countryToTest,
  bpName,
  setShowOption,
}: menuPageProps) => {
  const localeCode = swapCountryAndLanguage(langCode as IBMLocale);
  const [, setCurrency] = useState('');
  const [, setCountry] = useState('');
  // lang and userlocale is based out of ddo
  const [, userLocale] = useLang(
    countryList,
    test,
    countryToTest,
    setCurrency,
    setCountry,
    localeCode,
  );
  /* Have urx form deault in us-en when on language us page */
  const [localCurrency, setlocalCurrency] = useState<string>(localeCode);
  useEffect(() => {
    setlocalCurrency(userLocale); // show local Currency
  }, [userLocale, localeCode, localCurrency]);

  let localStorageFound = localStorage.getItem('langLocale');
  if (localStorageFound == null)
    localStorageFound = LangDefaults.localCountryLang;
  const picture = 'images/cognos.png';

  return (
    <div>
      <div className="bx--grid" id="menu-page">
        <div className="bx--row section">
          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-2">
            {bpName ? (
              <>
                <div className="bx--row figma_top">
                  <div className="bx--col"></div>
                </div>
              </>
            ) : null}
            <div className="bx--row mar1 mar5-left">
              <div className="bx--col-lg-16">
                <p className="type1">
                  <FormattedMessage {...messages.landing_title} />
                </p>
              </div>
            </div>
            <div className="bx--row mar5-left mar6-bottom">
              <div className="bx--col-lg-7">
                <div className="bx--row mar2">
                  <div className="bx--col-lg-16">
                    <p className="type2">
                      <FormattedMessage {...messages.landing_subtitle} />
                    </p>
                  </div>
                </div>
                <div className="bx--row mar2">
                  <div className="bx--col-lg-16">
                    <p className="type3">
                      <FormattedMessage {...messages.landing_text} />
                    </p>
                  </div>
                </div>
                <div className="bx--row mar3">
                  <div className="bx--col-lg-16">
                    <p className="type3">
                      <FormattedMessage {...messages.landing_choose_title} />
                    </p>
                  </div>
                </div>
                <div className="bx--row mar4">
                  <div className="bx--col-lg-8">
                    <Tile
                      aria-label="Start demo"
                      id="clickable-tile-1"
                      onClick={() => {
                        setShowOption(1);
                      }}
                      role="button"
                    >
                      <p className="type4">
                        <FormattedMessage {...messages.landing_title1} />
                      </p>
                      <br />
                      <br />
                      <Button
                        className="button-header"
                        kind="tertiary"
                        renderIcon={ArrowRight16}
                        onClick={() => {
                          segmentsTracking('CTA Clicked', {
                            pageTitle: 'IBM Cognos demo Demo',
                            object: 'CTA Start button',
                            resultValue: 'Demo button clicked',
                            CTA: 'Start demo CTA',
                            location: 'Demo',
                            action: 'Demo button clicked',
                            field: '',
                          });
                        }}
                      >
                        <FormattedMessage {...messages.tile1_button} />
                      </Button>
                    </Tile>
                  </div>
                  <div className="bx--col-lg-8"></div>
                </div>
              </div>
              <div className="bx--col-lg-9 bx--col-md-16 bx--col-sm-5">
                <PublicImage
                  imgPath={picture}
                  widgetId="cognos-demo"
                  id="img1"
                  alt="Cognos Analytics picture Demo "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default menuPage;
